"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogButton = void 0;
function DialogButton(options) {
    return function (target, propertyKey) {
        if (!target.dialogButtons) {
            target.dialogButtons = [];
        }
        if (!propertyKey.endsWith("Button")) {
            throw new Error(`DialogButton property ${propertyKey} should end with "Button".`);
        }
        const buttonDescriptor = {
            button: target[propertyKey],
            label: options.label,
            propertyKey: propertyKey,
            style: options.style
        };
        target.dialogButtons.push(buttonDescriptor);
    };
}
exports.DialogButton = DialogButton;
//# sourceMappingURL=DialogButton.js.map